import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import AboutPage from '../Pages/About';
import PolicyPage from '../Pages/Policy';
import s from './App.scss';

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  page: string;
  appMounted: (pageName: string) => void;
}

const pageKeys = {
  policy_api: 'about:api',
  policy_copyright: 'about:copyright',
  policy_etiquette: 'about:etiquette',
  policy_points: 'about:points',
  policy_prints: 'about:prints',
  policy_privacy: 'about:privacy',
  policy_service: 'about:service',
  policy_submission: 'about:submission',
  policy_dreamup: 'about:dreamup',
  policy_accessibility: 'about:accessibility',
};
const pageComponents = {
  about: AboutPage,
};

const App: React.FC<Props> = ({ language, environment, page, appMounted }) => {
  useEffect(() => {
    appMounted('about');
  }, [appMounted]);

  let pageKey, PageComponent;
  if (pageKeys.hasOwnProperty(page)) {
    pageKey = pageKeys[page];
  } else if (pageComponents.hasOwnProperty(page)) {
    PageComponent = pageComponents[page];
  }

  return (
    <HelmetProvider>
      <DaApp
        language={language}
        environment={environment}
        ncContextProps={{
          PageComponent: FeedbackPageLoadable,
          DrawerComponent: DrawerLoadable,
        }}
        modalsRenderFunc={submitModalRenderer}
      >
        <SiteHeader />
        <div className={s['content-container']}>
          {pageKey ? (
            <PolicyPage i18nKey={pageKey} />
          ) : PageComponent ? (
            <PageComponent />
          ) : (
            <p>Your {page} page would go here</p>
          )}
        </div>
        <SiteFooter />
      </DaApp>
    </HelmetProvider>
  );
};
App.displayName = 'AboutApp';

export default App;
